import store from 'app/store';

export default function isUserAuthenticated() {
  const { auth } = store.get().getState();
  const expires = auth.get('expires');
  const token = auth.get('token');

  if (typeof token === 'string' && token.length) {
    if (Date.now() < expires) {
      return true;
    }
  }

  return false;
}
